module.exports = __webpack_public_path__ + "static/beyond-silence-de510635e534a8958cab25bdaf1f2119.png";